import React from "react";
import AboutUs from "../components/About/AboutUs";
import FullScreenImage from "../components/Home/ShowcaseSection";
import FloatingDegreeIcon from "../components/Home/FloatingDegreeIcon";
import Footer from "../components/sub-comp/MainFooter";
import Navbar from "../components/sub-comp/Navbar";
import FloatingSocialPanels from "../components/sub-comp/FloatingSocialPanels";

const About = () => {
  return (
    <div>
      <Navbar />
      <div className="mid-desktop-page">
      <FloatingDegreeIcon />
      <AboutUs />
      <FullScreenImage />
      </div>
      <Footer />
      <FloatingSocialPanels />
    </div>
  );
};

export default About;
